import { IFormResponses } from '@llws/lift-entity-interfaces';
import { Equal, IQueryCommandOptions, ISearchCommandOptions, Not, Null } from '@llws/dynamic-router-utils';
import { ActionContext } from 'vuex';
import {
  IApiResponse,
  IMetaResponse,
} from '@/shared';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const defaultGetSingleFilters: IQueryCommandOptions = {};
const adminGatewayResourcePath: string = '/v1/website-api/form_submissions';
const listViewName: string = '';
const showLogging: boolean = false;

interface IFormSubmissions extends IFormResponses {
  formName: string,
  formType: string,
  sourceTable: 'inquiries' | 'form_responses',
}

const base = new StoreBaseImplementationV2<IFormSubmissions>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced, // 'form-submissions/'

  state: {
    ...base.state,
    formNames: undefined,
  },

  getters: {
    ...base.getters,
    availableFormNames(state: (typeof base.state & { formNames?: string[] })): string[] {
      return [...state.formNames || []];
    },
  },

  mutations: {
    ...base.mutations,
    setFormNames(state: (typeof base.state & { formNames?: string[] }), payload: string[]) {
      state.formNames = payload;
    },
  },

  actions: {
    ...base.actions,
    async search(
      ctx: ActionContext<IFormSubmissions, (typeof base.state)>,
      payload: ISearchCommandOptions,
    ): Promise<IApiResponse<IFormSubmissions[], IMetaResponse>> {
      const result: IApiResponse<IFormSubmissions[], IMetaResponse> = await adminRequest.post('/v1/website-api/form_submissions/_search', payload);
      ctx.commit('set', result);
      return result;
    },
    async getFormNames(
      ctx: ActionContext<IFormSubmissions, (typeof base.state)>,
      payload: { websiteId: number, status: (IFormSubmissions['status']) },
    ) {
      const query = {
        alias: 'fs',
        selectDistinct: 'fs.formName',
        where: [
          Equal('fs.status', payload.status),
          Equal('fs.siteId', payload.websiteId),
          Not(Null('fs.formName')),
        ],
        orderBy: [
          {
            field: 'fs.formName',
            direction: 'asc',
          },
        ],
      } as ISearchCommandOptions;

      const result: IApiResponse<IFormSubmissions[], IMetaResponse> = await adminRequest.post('/v1/website-api/form_submissions/_search', query);
      if (result.data) {
        ctx.commit('setFormNames', result.data.map((data) => data.formName));
      }
    },
  },
};
